export default __webpack_public_path__ + "static/media/Group_36@3x.175cf24d.png";